import { c as _c } from "react/compiler-runtime";
import { useWaveDataFetching } from "./useWaveDataFetching";
import { useWavePagination } from "./useWavePagination";
import type { WaveDataStoreUpdater } from "./types";

/**
 * Main hook that manages wave data loading and caching
 * This is the primary hook that components will use
 */
export function useWaveDataManager(t0) {
  const $ = _c(15);
  const {
    updateData,
    getData,
    removeDrop
  } = t0;
  let t1;
  if ($[0] !== getData || $[1] !== removeDrop || $[2] !== updateData) {
    t1 = {
      updateData,
      getData,
      removeDrop
    };
    $[0] = getData;
    $[1] = removeDrop;
    $[2] = updateData;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    registerWave,
    cancelWaveDataFetch,
    syncNewestMessages
  } = useWaveDataFetching(t1);
  let t2;
  if ($[4] !== getData || $[5] !== removeDrop || $[6] !== updateData) {
    t2 = {
      updateData,
      getData,
      removeDrop
    };
    $[4] = getData;
    $[5] = removeDrop;
    $[6] = updateData;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    fetchNextPage,
    cancelPaginationFetch,
    fetchAroundSerialNo
  } = useWavePagination(t2);
  let t3;
  if ($[8] !== cancelPaginationFetch || $[9] !== cancelWaveDataFetch || $[10] !== fetchAroundSerialNo || $[11] !== fetchNextPage || $[12] !== registerWave || $[13] !== syncNewestMessages) {
    t3 = {
      registerWave,
      cancelWaveDataFetch,
      syncNewestMessages,
      fetchNextPage,
      cancelPaginationFetch,
      fetchAroundSerialNo
    };
    $[8] = cancelPaginationFetch;
    $[9] = cancelWaveDataFetch;
    $[10] = fetchAroundSerialNo;
    $[11] = fetchNextPage;
    $[12] = registerWave;
    $[13] = syncNewestMessages;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}